import { render, staticRenderFns } from "./BetSlip.vue?vue&type=template&id=f6068dfe&scoped=true"
import script from "./BetSlip.vue?vue&type=script&lang=js"
export * from "./BetSlip.vue?vue&type=script&lang=js"
import style0 from "./BetSlip.vue?vue&type=style&index=0&id=f6068dfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6068dfe",
  null
  
)

export default component.exports